import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@shared/auth';
import { AppRoute } from '@shared/constants';
import { stashAuthReturnUrl } from '@shared/utils';

/**
 * Generic permission guard that reads permissions from route data
 * Usage: Add data: { permissions: ['permission1', 'permission2'] } to your route
 */
export const PermissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const user = authService.user();

  if (!user.isInitialized) {
    stashAuthReturnUrl(state.url);
    router.navigate([AppRoute.Loading]);
    return false;
  }

  const requiredPermissions = route.data?.['permissions'] as string[];

  if (!requiredPermissions || requiredPermissions.length === 0) {
    console.warn('PermissionGuard: No permissions specified in route data');
    return router.parseUrl('/');
  }

  if (requiredPermissions.some((permission) => user.hasPermission(permission))) {
    return true;
  }

  // Returning false leaves the current URL in place. After login that URL is
  // `/loading`, so send the user to `/` and let RedirectGuard pick a home page.
  return router.parseUrl('/');
};
